import { render, staticRenderFns } from "./apiRecord.vue?vue&type=template&id=63f86ca8&scoped=true"
import script from "./apiRecord.vue?vue&type=script&lang=js"
export * from "./apiRecord.vue?vue&type=script&lang=js"
import style0 from "./apiRecord.vue?vue&type=style&index=0&id=63f86ca8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f86ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f86ca8')) {
      api.createRecord('63f86ca8', component.options)
    } else {
      api.reload('63f86ca8', component.options)
    }
    module.hot.accept("./apiRecord.vue?vue&type=template&id=63f86ca8&scoped=true", function () {
      api.rerender('63f86ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/device/apiRecord.vue"
export default component.exports